<template>
  <div class="result-table">
    <div class="t-table-header">{{ $t('resultView.table.headline') }}</div>
    <table class="t-table">
      <thead>
        <tr>
          <td>{{ $t('table.columns.rank') }}</td>
          <td>{{ $t('table.columns.playerName') }}</td>
          <td>{{ $t('table.columns.score') }}</td>
          <td v-if="!onlyGameResult">{{ $t('table.columns.tournamentScore') }}</td>
          <td v-if="!onlyGameResult">{{ $t('table.columns.tournamentRank') }}</td>
        </tr>
      </thead>
      <tbody data-qe-id="table-data">
        <tr v-for="result in data" :key="result.playerId" :class="{ highlighted: result.isOwnPlayer }">
          <td>{{ result.rank }}</td>
          <td>{{ result.playerName }}</td>
          <td v-if="state === 'pending' && !result.isOwnPlayer">{{ $t('resultView.table.state_pending_opponent') }}</td>
          <td v-else-if="state === 'pending' && result.isOwnPlayer">
            {{ $t('resultView.table.state_pending_myself') }}
          </td>
          <td v-else-if="state === 'lto'">-</td>
          <td v-else>{{ result.score }}</td>
          <td v-if="!onlyGameResult">{{ result.tournamentScore }}</td>
          <td v-if="!onlyGameResult">{{ result.tournamentRank }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup lang="ts">
import { RankingUi } from '@/model/CompetitionResult'
withDefaults(defineProps<{ data: Array<RankingUi>; onlyGameResult?: boolean; state: string }>(), {
  onlyGameResult: false,
  state: 'finished',
})
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import '~@npm/@gd/common-styles/lib/color-vars';
.result-table {
  .t-table-header {
    height: 3.5em;
  }
}
</style>
